import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from 'environments/environment';
import {Baseservice} from './baseservice';
import {AuthenticationService} from './authentication.service';


@Injectable()
export class PayGateService extends Baseservice {
    protected url: string = environment.payGateApi.url;
    protected icbmsUrl: string = environment.payGateApi.icbmsUrl;

    constructor(http: HttpClient, authentication: AuthenticationService) {
        super('document', http, authentication);
    }

    InitiateTransaction(REFERENCE, AMOUNT, EMAIL, RETURN_URL) {
        var payGateInitiateObj: any = {
            REFERENCE: REFERENCE,
            AMOUNT: AMOUNT,
            EMAIL: EMAIL,
            RETURN_URL: RETURN_URL
        };

        console.log('PayGate Initiate', payGateInitiateObj);
        return this.http.post(`${this.url}/initiate`, payGateInitiateObj);
    }

    AddTransaction(CarrierAccountId,Amount)
    {
      var payGateAddObj : any = {      
        CarrierAccountId:CarrierAccountId,
        AMOUNT:Amount
      };
      
      return this.http.post(`${this.icbmsUrl}/transaction/add`, payGateAddObj);
    }

}
